module.exports = __webpack_public_path__ + "img/ph_side copy.7661bdcf.jpg";